import { render } from "./ExecutorsList.vue?vue&type=template&id=3527c84a&scoped=true"
import script from "./ExecutorsList.vue?vue&type=script&lang=js"
export * from "./ExecutorsList.vue?vue&type=script&lang=js"

import "./ExecutorsList.vue?vue&type=style&index=0&id=3527c84a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3527c84a"]])

export default __exports__